import * as React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { EditableTable } from '../../../subs/EditableTable';
import { Workshop, PaymentTypeStrings, WorkshopStatusStrings, getWorkshops } from '../../../types/Workshop';

import { AlertProps } from '@mui/material/Alert';
import { useSnackbar } from '../../../../contexts/SnackBarContext';

export const WorkshopAdminView = () => {
    const { showSnackbar } = useSnackbar();
    const [allData, setallData] = React.useState<Workshop[]>([]);

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(() => {
        const fetchAllWorkshops = async () => {
            const allworkshopsResponse = await getWorkshops(new AbortController());
            if (allworkshopsResponse.failed) {
                showUserFeedback(allworkshopsResponse.errorText);
                return;
            }
            setallData(allworkshopsResponse.result);
        }
        fetchAllWorkshops();
    }, [showUserFeedback]);

    /*const processRowUpdate = (newRow: GridRowModel) => {
        const changedData = allData.find(row => row.id === newRow.id);
        if (!changedData) {
            showUserFeedback('Row not found', 'error');
            return newRow;
        }
        changedData.paymentType = newRow.paymentType as number;
        changedData.status = newRow.status as number;
        changedData.maxUsers = newRow.maxUsers as number;
        changedData.name = newRow.name as string;
        changedData.location = newRow.location as string;
        changedData.contactEmail = newRow.contactEmail as string;
        changedData.informationUrl = newRow.informationUrl as string;
        saveHandler(changedData);
        return newRow;
    };*/

    /*const saveHandler = async (changedData: Workshop) => {
        const updateUserRequest = await updateWorkshopUser(changedData, new AbortController());

        if (updateUserRequest.failed) {
            showUserFeedback(updateUserRequest.errorText);
            return;
        }
        const updateUser = updateUserRequest.result;
        let allUsersLoc = copyArrayWithIndexChanged(allData, allData.findIndex(tc => tc.id === updateUser.id), updateUser);
        setallData(allUsersLoc);
    };*/

    /*const processDelete = async (id: number) => {
        const deleteUserRequest = await deleteWorkshopUser(id, new AbortController());

        if (deleteUserRequest.failed) {
            showUserFeedback(deleteUserRequest.errorText);
            return;
        }
        let allUsersLoc = allData.filter(c => c.id !== id);
        setallData(allUsersLoc);
    };*/

    const columns: GridColDef[] = [
        {
            field: 'guid',
            headerName: 'GUID',
            flex: 2
        },
        {
            field: 'name',
            headerName: 'Workshop Name',
            flex: 1,
//            editable: true,
        },
        {
            field: 'location',
            headerName: 'Location',
            flex: 1,
            //            editable: true,
        },
        {
            field: 'contactEmail',
            headerName: 'Contact Email',
            flex: 1,
            //            editable: true,
        },
        {
            field: 'informationUrl',
            headerName: 'Information URL',
            flex: 1,
            //            editable: true,
        },
        {
            field: 'fee',
            headerName: 'Fee',
            flex: 1,
            //            editable: true,
        },
        {
            field: 'maxUsers',
            headerName: 'Max Users',
            flex: 1,
            //            editable: true,
        },
        {
            field: 'startDate',
            headerName: 'Start Date',
            flex: 1,
        },
        {
            field: 'endDate',
            headerName: 'End Date',
            flex: 1,
        },
        {
            field: 'paymentType',
            headerName: 'Payment Type',
            flex: 1,
            valueFormatter: (value?: number) => {
                if (value == null) {
                    return '';
                }
                return PaymentTypeStrings[value];
            },
            valueGetter: (value, row) => {
                if (value == null) {
                    return '';
                }
                return PaymentTypeStrings[value];
            },
            valueSetter: (value, row) => {
                let paymentType = 0;
                if (PaymentTypeStrings.find(v => v === value) !== null) {
                    for (let i = 0; i < PaymentTypeStrings.length; i++) {
                        if (PaymentTypeStrings[i] === value) {
                            paymentType = i;
                            break;
                        }
                    }
                }
                return { ...row, paymentType: paymentType };
            },
            type: 'singleSelect',
            valueOptions: PaymentTypeStrings
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            editable: true,
            valueFormatter: (value?: number) => {
                if (value == null) {
                    return '';
                }
                return WorkshopStatusStrings[value];
            },
            valueGetter: (value, row) => {
                if (value == null) {
                    return '';
                }
                return WorkshopStatusStrings[value];
            },
            valueSetter: (value, row) => {
                let status = 0;
                if (WorkshopStatusStrings.find(v => v === value) !== null) {
                    for (let i = 0; i < WorkshopStatusStrings.length; i++) {
                        if (WorkshopStatusStrings[i] === value) {
                            status = i;
                            break;
                        }
                    }
                }
                return { ...row, status: status };
            },
            type: 'singleSelect',
            valueOptions: WorkshopStatusStrings
        },
        {
            field: 'id'
        },
    ];

    return <React.Fragment >
        <Box sx={{ flexGrow: 1, width: "100%" }} style={{ overflow: 'auto' }}>
            <EditableTable
                columns={columns}
                rows={allData}
                setAllRows={setallData}
            //       processRowUpdate={processRowUpdate}
            //       processRowDelete={processDelete}
            />
        </Box>
    </React.Fragment >
}